import React, { FC } from 'react';

import { Container, Svg } from '@lglp/components';
import { useTranslation } from 'react-i18next';

import { ICON } from 'translations';

import styles from './NewsroomIcon.module.scss';

const NewsroomIcon: FC<NewsroomIconProps> = ({
  title = ICON.NEWSROOM1,
  className,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <Container className={[styles.container, className]} {...rest}>
      <Svg
        title={t(title)}
        viewBox="0 0 93.13 122.01"
        className={styles.newsroomFront}
      >
        <path
          className={styles.newsroomFirstPage}
          d="M11 15h60a8 8 0 0 1 8 8V105h-60a8 8 0 0 1-8-8z"
        />
        <path
          className={styles.newsroomLogo}
          d="M23.5 72h40M23.5 84h40M35.8 60L42 70l7-10M42 70V40"
        />
      </Svg>
      <Svg
        title={t(title)}
        viewBox="0 0 93.13 122.01"
        className={styles.newsroomBack}
      >
        <path
          className={styles.newsroomSecondPage}
          d="M20 5h60a8 8 0 0 1 8 8V95H29a8 8 0 0 1-8-8z"
        />
      </Svg>
    </Container>
  );
};

type NewsroomIconProps = {
  title?: string;
  className?: string;
};

export default NewsroomIcon;
